export const programsData = {
  hero:17,
  mommy:18,
  extreme:19,
  tomorrow:20
}
function range(start, count) {
  return Array.apply(0, Array(count))
    .map(function (element, index) {
      return index + start;
    });
}
export const dataHeight= range(140, 81)

export const social = {
  vk:{
    id:1,
    clientId:6420905
  },
  ok:{
    id:2,
    app_id: 1264634880,
    app_key: 'CBANMBGMEBABABABA'
  },
  fb:{
    id:3,
    clientId:978521608971564
  },
  gp:{
    id:4,
    clientId:'458625587484-cnn9frk7pem7fd79rks25r04o3c6uarr.apps.googleusercontent.com'
  },
  in:{
    id:5,
    clientId:'a766db83c87740f1b038cb0e27b7a4f7'
  }
}



// WEBPACK FOOTER //
// /var/www/build-lk-1/src/utils/data.js